<script setup lang="ts">
import { computed } from 'vue'
import { Badge } from '@/components/ui/badge'
import type { BadgeVariants } from '@/components/ui/badge'

// Scoped to one country and one side, so an absent side renders nothing at all
// rather than a zero — an empty market and a market with no listings are not the
// same answer.
//
// `plain` drops the badge chrome for the dense grid, where a pill per row per side
// was the widest thing in a narrow column and its fill fought the row's own
// striping. The dot and the number carry the meaning; the colour then comes from
// whatever the caller sets on the surrounding text, which is how `Grade` does it.
const props = withDefaults(
    defineProps<{
        value: number | null | undefined
        variant?: BadgeVariants['variant']
        plain?: boolean
    }>(),
    {
        variant: 'secondary',
    },
)

const hasValue = computed(() => props.value !== null && props.value !== undefined)
</script>

<template>
    <Badge v-if="hasValue && !plain" :variant="variant" class="shrink-0">
        <span class="relative flex size-1.5 mr-1">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-50" />
            <span class="relative inline-flex size-1.5 rounded-full bg-current" />
        </span>
        {{ value }}
    </Badge>

    <span v-else-if="hasValue" class="shrink-0 inline-flex items-center text-xs font-medium tabular-nums">
        <span class="relative flex size-1.5 mr-1">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-50" />
            <span class="relative inline-flex size-1.5 rounded-full bg-current" />
        </span>
        {{ value }}
    </span>
</template>
